import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { AuthInterceptor } from "../auth/auth.interceptor";
import { UserService } from "app/modules/user/users/user.service";

@NgModule({
    imports  : [
        HttpClientModule
    ],
    providers: [
        UserService,
        {
            provide : HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi   : true
        }
    ]
})
export class UserServiceModule
{
}